import React from 'react';
import { Award } from 'lucide-react';

interface Badge {
  id: string;
  name: string;
  description: string;
  icon: string;
  requirement: string;
  tier: 'bronze' | 'silber' | 'gold';
}

const BADGES: Badge[] = [
  { id: 'first_question', name: 'Erste Schritte', description: 'Erste Frage beantwortet', icon: '🎯', requirement: '1 Frage beantwortet', tier: 'bronze' },
  { id: 'ten_correct', name: 'Durchstarter', description: '10 richtige Antworten', icon: '⭐', requirement: '10 korrekte Antworten', tier: 'bronze' },
  { id: 'first_chapter', name: 'Kapitelmeister', description: 'Erstes Kapitel abgeschlossen', icon: '📖', requirement: '1 Kapitel zu 100%', tier: 'bronze' },
  { id: 'streak_7', name: 'Wochenkönig', description: '7 Tage Streak', icon: '🔥', requirement: '7 Tage am Stück gelernt', tier: 'silber' },
  { id: 'fifty_correct', name: 'Halbzeit', description: '50 richtige Antworten', icon: '🏅', requirement: '50 korrekte Antworten', tier: 'silber' },
  { id: 'all_chapters', name: 'Alleskönner', description: 'Alle Kapitel abgeschlossen', icon: '🏆', requirement: '14 Kapitel zu 100%', tier: 'gold' },
  { id: 'exam_passed', name: 'Prüfungsprofi', description: 'Prüfungssimulation bestanden', icon: '✅', requirement: 'Simulation mit ≥80%', tier: 'silber' },
  { id: 'streak_30', name: 'Marathonläufer', description: '30 Tage Streak', icon: '💎', requirement: '30 Tage am Stück gelernt', tier: 'gold' },
  { id: 'hundred_correct', name: 'Centurio', description: '100 richtige Antworten', icon: '💯', requirement: '100 korrekte Antworten', tier: 'silber' },
  { id: 'perfect_exam', name: 'Perfektionist', description: 'Simulation mit 100%', icon: '👑', requirement: 'Simulation ohne Fehler', tier: 'gold' },
  { id: 'speed_demon', name: 'Blitzmerker', description: '10 Fragen in unter 2 Min', icon: '⚡', requirement: '10 Fragen < 2 Min', tier: 'silber' },
  { id: 'ai_chat', name: 'Wissbegierig', description: 'KI-Coach genutzt', icon: '🤖', requirement: '1 Chat mit KI-Coach', tier: 'bronze' },
];

const tierColors = {
  bronze: { bg: '#cd7f32', text: 'white', label: 'Bronze' },
  silber: { bg: '#c0c0c0', text: '#333', label: 'Silber' },
  gold: { bg: '#ffd700', text: '#333', label: 'Gold' },
};

export const BadgesPage: React.FC = () => {
  const grouped = {
    bronze: BADGES.filter(b => b.tier === 'bronze'),
    silber: BADGES.filter(b => b.tier === 'silber'),
    gold: BADGES.filter(b => b.tier === 'gold'),
  };

  return (
    <div>
      <div className="page-header"><h1><Award size={24} /> Badges</h1></div>

      <div className="grid-cols-3 mb-6">
        <div className="kpi-card">
          <span className="kpi-label">Bronze</span>
          <span className="kpi-value">{grouped.bronze.length}</span>
        </div>
        <div className="kpi-card">
          <span className="kpi-label">Silber</span>
          <span className="kpi-value">{grouped.silber.length}</span>
        </div>
        <div className="kpi-card">
          <span className="kpi-label">Gold</span>
          <span className="kpi-value">{grouped.gold.length}</span>
        </div>
      </div>

      {(['bronze', 'silber', 'gold'] as const).map(tier => (
        <div key={tier} className="mb-6">
          <h3 style={{ marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{
              display: 'inline-block', width: 12, height: 12, borderRadius: '50%',
              background: tierColors[tier].bg,
            }} />
            {tierColors[tier].label} ({grouped[tier].length} Badges)
          </h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 12 }}>
            {grouped[tier].map(badge => (
              <div key={badge.id} className="card" style={{ padding: 16, display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                <div style={{
                  width: 48, height: 48, borderRadius: 12,
                  background: `${tierColors[tier].bg}22`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 24, flexShrink: 0,
                }}>
                  {badge.icon}
                </div>
                <div>
                  <h4 style={{ marginBottom: 2 }}>{badge.name}</h4>
                  <p className="text-sm text-muted">{badge.description}</p>
                  <p className="text-xs text-muted mt-1">Bedingung: {badge.requirement}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
